module.exports = __webpack_public_path__ + "media/images/japan/raw-underline-1f12ba3e00322a19100843f494d8a7c9.svg";